define( [
	"../core"
], function( jQuery ) {

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var elem,
		i = 0;
	for ( ; ( elem = elems[ i ] ) != null; i++ ) {
		jQuery._data(
			elem,
			"globalEval",
			!refElements || jQuery._data( refElements[ i ], "globalEval" )
		);
	}
}

return setGlobalEval;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/manipulation/setGlobalEval.js